import { ExclamationCircleIcon } from "@heroicons/react/24/outline"
import PropTypes from "prop-types"

const ErrorPlaceholder = ({ 
  caption, 
  classNames = "", 
  error = null,
  errors = null,
}) => (
  <div className={`${classNames} relative flex flex-col items-center justify-center grow p-12 text-center border-2 border-dashed rounded-lg text-gray-300 dark:border-content2-foreground`}>
    <ExclamationCircleIcon className="h-24 mb-2 text-indigo-800 dark:text-content2-foreground" />
    <p className="block mb-1 text-lg font-semibold text-foreground dark:text-white">{caption}</p>
    {error && <p className="text-red-600 dark:text-white">{error.message}</p>}
    
    {errors &&
      <ul className="w-full mt-3 text-center">
        {Object.keys(errors).map((key) => {
          const error = errors[key]

          return (
            <li className="font-semibold text-danger" key={key}>
              * {error}
            </li>
          )
        })}
      </ul>
    }
  </div>
)

ErrorPlaceholder.propTypes = {
  caption: PropTypes.string,
  classNames: PropTypes.string,
  error: PropTypes.object,
  errors: PropTypes.array,
}

export default ErrorPlaceholder